import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle  from '@material-ui/core/DialogTitle';

const CustomPrompt = ({ message, onConfirm, onCancel }) => {
  const parsedMessage = JSON.parse(message);
  const {
    title,
    description,
    confirmationText,
    cancellationText,
    dialogProps,
    confirmButtonProps,
  } = parsedMessage;

  return (
    <Dialog  {...dialogProps} fullWidth open onClose={onCancel}>
      {title && <DialogTitle>{title}</DialogTitle>}
      {description && (
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            color={'textPrimary'}
          >
            {description}
          </DialogContentText>
        </DialogContent>
      )}
      <DialogActions>
        <Button onClick={onCancel}>
          {cancellationText || 'Cancel'}
        </Button>
        <Button onClick={onConfirm} color="primary" {...confirmButtonProps}>
          {confirmationText || 'Ok'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomPrompt;
